/**
 * Действие из тултипа графика. label — фрагмент первой строки записи (например, номер документа),
 * он и становится ссылкой. Что открывать, решает потребитель: график про предметную область ничего не знает
 */
class ChartAction {
  readonly label: string;

  readonly callback: () => void;

  constructor(label: string, callback: () => void) {
    this.label = label;
    this.callback = callback;
  }
}

export default ChartAction;
